import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const Fakturace = {
	name: NAME,
	apiProvider,
	router,
};
